import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BottomBarService {
  private showBottomBarSubject = new BehaviorSubject<boolean>(true);
  private showNavBarSubject = new BehaviorSubject<boolean>(true);

  showBottomBar$ = this.showBottomBarSubject.asObservable();
  showNavBar$ = this.showNavBarSubject.asObservable();

  showBottomBar() {
    this.showBottomBarSubject.next(true);
  }

  hideBottomBar() {
    this.showBottomBarSubject.next(false);
    this.showNavBarSubject.next(false);
  }

  hideNavBar() {
    this.showNavBarSubject.next(false);
  }

  showNavBar() {
    this.showNavBarSubject.next(true);
  }
}
